import { render } from "./AddOuvFerm.vue?vue&type=template&id=0ee6a1a0&scoped=true&ts=true"
import script from "./AddOuvFerm.vue?vue&type=script&lang=ts"
export * from "./AddOuvFerm.vue?vue&type=script&lang=ts"

import "./AddOuvFerm.vue?vue&type=style&index=0&id=0ee6a1a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee6a1a0"]])

export default __exports__